import { saveAs } from 'file-saver';
import { utils, write } from 'xlsx';
import { EXCEL_HEADERS } from '../constants/lifeInsuranceConstants';
export { formatCurrency } from '../../../utils/formatUtils';

function s2ab(s) {
  const buf = new ArrayBuffer(s.length);
  const view = new Uint8Array(buf);
  for (let i = 0; i < s.length; i++) {
    view[i] = s.charCodeAt(i) & 0xff;
  }
  return buf;
}

const exportLifeInsuranceExcel = (dataToExport, fileName) => {
  const fileType =
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  const fileExtension = '.xlsx';

  const dataToDownload = dataToExport.map((item) => [
    item.plan,
    item.group,
    item.order,
    item.subscriber,
    item.installmentDebtBalance,
    item.pureInstallment,
    item.debtBalanceInPesos,
    item.lifeInsurance,
  ]);

  const ws = utils.aoa_to_sheet([EXCEL_HEADERS, ...dataToDownload]);
  const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
  const excelBuffer = write(wb, { bookType: 'xlsx', type: 'binary' });
  const data = new Blob([s2ab(excelBuffer)], { type: fileType });
  saveAs(data, `${fileName}${fileExtension}`);
};

export const downloadExcel = (dataToExport) => {
  exportLifeInsuranceExcel(dataToExport, 'Seguro de vida');
};

export const downloadExcelForInsurer = (dataToExport) => {
  exportLifeInsuranceExcel(dataToExport, 'Seguro de vida - aseguradora');
};
